import { apiGet, apiPost, apiFileGet } from '../../api/api-configuration';
import { failureAction, downloadFileBlob } from '../../app-actions';
import { escapeHTML } from '../ssm-homepage/ssm-homepage.actions';
import {
  API_GET_NGM_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_NGM_CUSTOMER_DATA,
  API_COMPLETE_GET_NGM_CUSTOMER_DATA,
  API_POST_NGM_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_NGM_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA,
  API_INITIATE_POST_NGM_RECOMMEND_PLAN_DATA,
  API_COMPLETE_POST_NGM_RECOMMEND_PLAN_DATA,
  API_POST_NGM_RECOMMEND_PLAN_DATA_ENDPOINT,
  NGM_NO_TEXT,
  API_GET_NGM_CUSTOMER_DOWNLOAD_CSV_FILE,
  API_INITIATE_GET_NGM_DOWNLOAD_CSV_FILE,
  API_COMPLETE_GET_NGM_DOWNLOAD_CSV_FILE,
  DEBUG_MODE,
} from '../../app-constants';

export const successActionNGMCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_NGM_CUSTOMER_DATA, data };
};

export const getNGMCustomerData = data => (dispatch) => {
  const endpoint = `${API_GET_NGM_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_NGM_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successActionNGMCustomerData, failureAction, data);
};

export const successActionSubmitNGM = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_NGM_CUSTOMER_DATA, data };
};

export const submitNGMCustomerData = data => (dispatch) => {
  const endpoint = API_POST_NGM_CUSTOMER_DATA_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: API_INITIATE_SUBMIT_NGM_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitNGM, failureAction, dataWithEncryptedCidn);
};


export const successActionSubmitNGMRecommendPlan = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_POST_NGM_RECOMMEND_PLAN_DATA, data };
};


export const submitNGMRecommendPlanData = data => (dispatch) => {
  const endpoint = API_POST_NGM_RECOMMEND_PLAN_DATA_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: API_INITIATE_POST_NGM_RECOMMEND_PLAN_DATA });
  apiPost(dispatch, endpoint, successActionSubmitNGMRecommendPlan, failureAction, dataWithEncryptedCidn);
};

export const successActionDownloadCSVFile = (response) => {
  downloadFileBlob(response, 'Adaptive-Mobility-Fleet-Summary.xls', 'application/vnd.ms-excel');
  return { type: API_COMPLETE_GET_NGM_DOWNLOAD_CSV_FILE };
};


export const downloadCSVFile = data => (dispatch) => {
  const currentAccount = window.parent.tcom.researchInsights.appConfig.currentAccount;
  const endpoint = `${API_GET_NGM_CUSTOMER_DOWNLOAD_CSV_FILE}?value=${encodeURIComponent(currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_NGM_DOWNLOAD_CSV_FILE });
  apiFileGet(dispatch, endpoint, successActionDownloadCSVFile, failureAction, data);
};

export const preparePostCallArray = (stateData, customerQuestionAuthorable) => {
  let preparedata = {};
  const prepareRecommendations = [];
  stateData.performanceSelectedOptions.map((options) => {
    const [questionIndex, selectedValue] = options.split('-');
    prepareRecommendations.push({
      question: customerQuestionAuthorable.performanceQuestions[questionIndex].questionText,
      answer: customerQuestionAuthorable.performanceQuestions[questionIndex].options[parseInt(selectedValue, 10) - 1] !== undefined ?
        customerQuestionAuthorable.performanceQuestions[questionIndex].options[parseInt(selectedValue, 10) - 1].value : '',
    });
    return true;
  });

  Object.keys(stateData.customerSelectedOptions).map((key) => {
    const recommendation = {
      question: customerQuestionAuthorable.questions[parseInt(key, 10) - 1].questionText,
      answer: stateData.customerSelectedOptions[key].join('|'),
    };
    return prepareRecommendations.push(recommendation);
  });

  preparedata = {
    captureUserSelections: prepareRecommendations,
    comments: escapeHTML(stateData.preferredTimeContacted),
    recommendedPlan: stateData.recommendedPlanType,
    searchUsed: stateData.searchUsed,
    addOnLinks: window.tcom.researchInsights.appConfig.ngmAddonsClickedTexts,
    liveChatUsed: NGM_NO_TEXT,
  };
  return preparedata;
};


export const prepareRecommendPlanPostCallData = (recommendedPlanType, searchUsed) => {
  const preparedata = {
    recommendedPlan: recommendedPlanType,
    searchUsed,
    addOnLinks: window.tcom.researchInsights.appConfig.ngmAddonsClickedTexts,
  };
  return preparedata;
};


export const prepareDefaultState = (questions) => {
  let preparedata = {};
  const performanceQuestions = [];
  questions.performanceQuestions.map((question, index) => {
    performanceQuestions.push(`${index}-${question.defaultState}`);
    return performanceQuestions;
  });

  const customerSelectedOptionsArr = [];
  questions.questions.map((question, index) => {
    customerSelectedOptionsArr[index + 1] = [];
    return customerSelectedOptionsArr;
  });

  preparedata = {
    performanceSelectedOptions: performanceQuestions,
    customerSelectedOptions: customerSelectedOptionsArr,
  };
  return preparedata;
};

export const preparePerformanceOptionsArry = (options, QuestionIndex) => {
  const prepareOptions = [];
  options.map((option) => {
    prepareOptions.push({
      label: option.value,
      value: `${QuestionIndex}-${option.key}`,
    });
    return prepareOptions;
  });
  return prepareOptions;
};

export const getRecommendedPlanType = (performanceSelectedOptions) => {
  let sumOfSelectionOptions = 0;
  let recommendedPlan;
  performanceSelectedOptions.map((data) => {
    sumOfSelectionOptions += parseInt(data.split('-')[1], 10);
    return sumOfSelectionOptions;
  });

  if (DEBUG_MODE) {
    console.log(sumOfSelectionOptions); // eslint-disable-line
  }
  if (sumOfSelectionOptions <= 4) {
    recommendedPlan = 'recommendationLite';
  } else if (sumOfSelectionOptions <= 7) {
    recommendedPlan = 'recommendationMid';
  } else {
    recommendedPlan = 'recommendationMax';
  }
  return recommendedPlan;
};
